import React from 'react';
import './PrintData.css';

class PrintData extends React.Component {
    render() {
        var printBodyData = this.props.printtableData.map((printdata, index) => {
            return (
                <tr>
                    <td>{index + 1}</td>
                    <td>{printdata.orderId}</td>
                    <td>{printdata.customer}</td>
                    <td>{printdata.doctorName}</td>
                    <td>{printdata.prescriptionDate}</td>
                    <td>{printdata.status}</td>
                </tr>
            )
        })
        return (
            <div className="printtabledata">
                <div className="printDataTitle">Order Processsing</div>
                <table>
                    <thead>
                        <th>S.No</th>
                        <th>Order Id</th>
                        <th>Customer</th>
                        <th>Doctor Name</th>
                        <th>Prescription Date</th>
                        <th>Remarks</th>
                    </thead>
                    <tbody>
                        {printBodyData}
                    </tbody>
                </table>
            </div>
        )
    }
}

export default PrintData;
